/* eslint-disable react/prop-types */
// Modules
import React, { useEffect } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import Layout from 'Components/layout/Layout.jsx';
import Headline from 'Components/headline/Headline.jsx';
import BCrumb from 'Components/Bcrumb/BCrumb.jsx';
import Faq from 'Components/faq/Faq.jsx';
import { ROUTE_ERROR_PAGE } from 'Constants/routes';
import { useGetTopicQuery } from 'Services/api';
import { sendAnalyticEvent } from '../../utils/analytics';
import TopicsBlock from './TopicsBlock.jsx';

// styles
import './Home.scss';
import TopicsBlockSkeleton from './TopicsBlock.skeleton';
import Loader from '../../components/loading/Loader';

const Home = ({ history }) => {
    const location = useLocation();

    useEffect(() => {
        const currentPath = location.pathname + location.search;
        sendAnalyticEvent({ category: 'pageview', pagePath: currentPath });
    }, [location]);

    const { data: pages, isError, isLoading } = useGetTopicQuery();

    if (isError) {
        return history.push(ROUTE_ERROR_PAGE);
    }

    const homePageTopics = pages?.topics;

    return (
        <Layout>
            <BCrumb />
            <Loader
                isLoading={isLoading}
                loaderMarginTop="60px"
                loaderWidth="505px"
                loaderHeight="106px"
            >
                {pages && <Headline title={pages.headline} description={pages.body} />}
            </Loader>
            <div className="topic-wrapper">
                {isLoading && <TopicsBlockSkeleton />}
                {pages && <TopicsBlock homeTopics={homePageTopics} loading={isLoading} />}
            </div>
            {pages && <Faq />}
        </Layout>
    );
};

export default withRouter(Home);
